import { render, staticRenderFns } from "./SolAgoraJuridico.vue?vue&type=template&id=ac58e20c&"
import script from "./SolAgoraJuridico.vue?vue&type=script&lang=js&"
export * from "./SolAgoraJuridico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports